// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accePage {
  min-height: 100%;
  padding: 22px;
  color: #f4f4f4;
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),
    #050505;
}

/* ================= SHARED ================= */

.acceHeroContent,
.accePanel {
  border: 1px solid rgba(177, 136, 0, 0.28);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),
    #0b0b0b;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);
}

.acceHeroContent,
.accePanel {
  padding: 20px;
}

.acceEyebrow,
.acceSectionLabel,
.acceInputLabel,
.acceStatCard span,
.acceSizingOutput span,
.acceSizingMeta span,
.acceInfoBlock span,
.acceTradeTable th {
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.acceEyebrow,
.acceSectionLabel,
.acceInfoBlock span {
  color: #d8b44c;
  font-size: 0.72rem;
}

.accePanelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.accePanelHeader h3 {
  margin: 6px 0 0;
  color: #ffffff;
  font-size: 1.15rem;
  line-height: 1.2;
}

/* ================= PAGE LAYOUT ================= */

.accePageGrid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(360px, 0.65fr);
  gap: 18px;
  align-items: start;
}

.acceLeftColumn,
.acceRightColumn {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ================= HERO ================= */

.acceHeroContent {
  padding: 24px 28px;
}

.acceEyebrow {
  display: inline-flex;
  width: fit-content;
  letter-spacing: 0.11em;
}

.acceHeroContent h1 {
  margin: 10px 0 0;
  color: #ffffff;
  font-size: clamp(2.4rem, 4vw, 4rem);
  line-height: 0.95;
  letter-spacing: 0.02em;
}

.acceHeroContent h2 {
  margin: 8px 0 0;
  color: #b18800;
  font-size: clamp(1.2rem, 2vw, 1.7rem);
  font-weight: 800;
}

.acceHeroContent p {
  max-width: 900px;
  margin: 14px 0 0;
  color: rgba(244, 244, 244, 0.74);
  font-size: 0.96rem;
  line-height: 1.58;
}

/* ================= HERO ACTIONS ================= */

.acceHeroActions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.accePrimaryButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 11px 15px;
  border: 1px solid rgba(177, 136, 0, 0.52);
  border-radius: 12px;
  color: #f4d06f;
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.18), rgba(255, 255, 255, 0.035)),
    rgba(177, 136, 0, 0.08);
  font-size: 0.82rem;
  font-weight: 900;
  text-decoration: none;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);
  transition:
    background 160ms ease,
    border-color 160ms ease,
    transform 160ms ease;
}

.accePrimaryButton:hover {
  border-color: rgba(216, 180, 76, 0.78);
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.26), rgba(255, 255, 255, 0.05)),
    rgba(177, 136, 0, 0.12);
  transform: translateY(-1px);
}

/* ================= STATS ================= */

.acceStatsGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.acceStatCard,
.acceSizingMeta div,
.acceInfoBlock {
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
}

.acceStatCard {
  min-width: 0;
  padding: 16px;
}

.acceStatCard span,
.acceSizingMeta span {
  display: block;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.7rem;
}

.acceStatCard strong {
  display: block;
  margin-top: 10px;
  color: #ffffff;
  font-size: 1.45rem;
  line-height: 1;
}

.acceStatCard small {
  display: block;
  margin-top: 8px;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.75rem;
}

.acceStatCard--positive strong {
  color: #55d17a;
}

.acceStatCard--negative strong {
  color: #ff6464;
}

.accePanelPill {
  white-space: nowrap;
  padding: 7px 10px;
  border: 1px solid rgba(177, 136, 0, 0.42);
  border-radius: 999px;
  color: #f4d06f;
  background: rgba(177, 136, 0, 0.08);
  font-size: 0.72rem;
  font-weight: 800;
}

/* ================= TRADE TABLE ================= */

.acceTradeTableWrap {
  width: 100%;
  overflow-x: auto;
}

.acceTradeTable {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
}

.acceTradeTable th {
  padding: 11px 12px;
  color: rgba(244, 244, 244, 0.52);
  font-size: 0.72rem;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.acceTradeTable td {
  padding: 13px 12px;
  color: rgba(244, 244, 244, 0.82);
  font-size: 0.86rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
}

.acceTradeTable tbody tr:hover {
  background: rgba(177, 136, 0, 0.055);
}

.acceResultPill {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  color: rgba(244, 244, 244, 0.75);
  background: rgba(255, 255, 255, 0.07);
  font-size: 0.75rem;
  font-weight: 800;
}

.acceResultPill--positive {
  color: #55d17a;
  background: rgba(85, 209, 122, 0.1);
}

.acceResultPill--negative {
  color: #ff6464;
  background: rgba(255, 100, 100, 0.1);
}

.accePnlCell {
  font-weight: 800;
}

.accePnlCell--positive {
  color: #55d17a !important;
}

.accePnlCell--negative {
  color: #ff6464 !important;
}

.acceEmptyTableCell {
  padding: 18px 12px;
  color: rgba(244, 244, 244, 0.48);
  text-align: center;
}

.accePanelSubtext {
  margin: 6px 0 0;
  color: rgba(244, 244, 244, 0.48);
  font-size: 0.78rem;
  line-height: 1.4;
}

/* ================= CALCULATOR ================= */

.acceCalculatorPanel {
  border-color: rgba(216, 180, 76, 0.42);
  background:
    radial-gradient(circle at top right, rgba(177, 136, 0, 0.14), transparent 38%),
    #0b0b0b;
}

.acceCalculatorIntro,
.acceInfoBlock p {
  margin: 0;
  color: rgba(244, 244, 244, 0.68);
  font-size: 0.9rem;
  line-height: 1.55;
}

.acceCalculatorIntro {
  margin-bottom: 18px;
}

.acceInputLabel {
  display: block;
  margin-bottom: 8px;
  color: rgba(244, 244, 244, 0.62);
  font-size: 0.76rem;
}

.acceInputShell {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 0 14px;
  border: 1px solid rgba(177, 136, 0, 0.34);
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.45);
}

.acceInputShell span {
  color: #d8b44c;
  font-weight: 900;
}

.acceInputShell input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  color: #ffffff;
  background: transparent;
  font-size: 1rem;
  font-weight: 800;
}

.acceSizingOutput {
  margin-top: 14px;
  padding: 16px;
  border: 1px solid rgba(177, 136, 0, 0.34);
  border-radius: 16px;
  background:
    linear-gradient(145deg, rgba(177, 136, 0, 0.13), rgba(255, 255, 255, 0.03)),
    rgba(0, 0, 0, 0.3);
}

.acceSizingOutput span {
  display: block;
  color: rgba(244, 244, 244, 0.58);
  font-size: 0.68rem;
}

.acceSizingOutput strong {
  display: block;
  margin-top: 8px;
  color: #ffffff;
  font-size: 1.75rem;
  line-height: 1.1;
}

.acceSizingOutput small {
  display: block;
  margin-top: 10px;
  color: rgba(244, 244, 244, 0.56);
  font-size: 0.82rem;
}

.acceSizingNotice {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 193, 7, 0.28);
  border-radius: 12px;
  color: #f4d06f;
  background: rgba(255, 193, 7, 0.08);
  font-size: 0.82rem;
  font-weight: 700;
}

.acceSizingMeta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.acceSizingMeta div {
  padding: 12px;
  border-radius: 14px;
}

.acceSizingMeta strong {
  display: block;
  margin-top: 7px;
  color: #ffffff;
  font-size: 0.95rem;
}

.acceSizingDisclaimer {
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.075);
  color: rgba(244, 244, 244, 0.46);
  font-size: 0.74rem;
  line-height: 1.45;
}

/* ================= INFO ================= */

.acceInfoStack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.acceInfoBlock {
  padding: 14px;
}

.acceInfoBlock span {
  display: block;
  margin-bottom: 7px;
}

.acceWhitePaperLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  padding: 11px 14px;
  border: 1px solid rgba(177, 136, 0, 0.42);
  border-radius: 12px;
  color: #f4d06f;
  background: rgba(177, 136, 0, 0.08);
  font-size: 0.82rem;
  font-weight: 900;
  text-decoration: none;
  transition:
    background 160ms ease,
    border-color 160ms ease,
    transform 160ms ease;
}

.acceWhitePaperLink:hover {
  border-color: rgba(216, 180, 76, 0.72);
  background: rgba(177, 136, 0, 0.16);
  transform: translateY(-1px);
}

/* ================= DISCLAIMER ================= */

.acceDisclaimer {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.075);
  border-radius: 14px;
  color: rgba(244, 244, 244, 0.42);
  background: rgba(255, 255, 255, 0.025);
  font-size: 0.74rem;
  line-height: 1.45;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 1180px) {
  .accePageGrid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 860px) {
  .accePage {
    padding: 16px;
  }

  .acceStatsGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .acceHeroContent,
  .accePanel {
    border-radius: 16px;
  }
}

@media (max-width: 560px) {
  .acceStatsGrid,
  .acceSizingMeta {
    grid-template-columns: 1fr;
  }

  .accePanelHeader {
    flex-direction: column;
  }

  .acceHeroContent,
  .accePanel {
    padding: 16px;
  }
}



/*These fixes are for the mobile views to align with argos and meic*/

/* ================= MOBILE WIDTH / OVERFLOW FIX ================= */

.accePage,
.accePageGrid,
.acceLeftColumn,
.acceRightColumn,
.acceHeroContent,
.accePanel {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.accePage {
  overflow-x: hidden;
}

.acceHeroContent {
  position: relative;
  overflow: hidden;
}

.acceHeroContent h1,
.acceHeroContent h2,
.acceHeroContent p {
  max-width: 100%;
  overflow-wrap: break-word;
}

.acceHeroActions {
  flex-wrap: wrap;
}

.accePrimaryButton {
  max-width: 100%;
  white-space: normal;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/ACCEPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;WAES;AACX;;AAEA,+CAA+C;;AAE/C;;EAEE,yCAAyC;EACzC,mBAAmB;EACnB;;WAES;EACT,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6CAA6C;;AAE7C;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd;;2BAEyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C;;;wBAGsB;AACxB;;AAEA;EACE,sCAAsC;EACtC;;2BAEyB;EACzB,2BAA2B;AAC7B;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;EAGE,4CAA4C;EAC5C,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mDAAmD;;AAEnD;EACE,sCAAsC;EACtC;;WAES;AACX;;AAEA;;EAEE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB;;sBAEoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,6CAA6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB;;;wBAGsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,mDAAmD;;AAEnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mDAAmD;;AAEnD;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;AACF;;;;AAIA,oEAAoE;;AAEpE,oEAAoE;;AAEpE;;;;;;EAME,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".accePage {\n  min-height: 100%;\n  padding: 22px;\n  color: #f4f4f4;\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.12), transparent 34%),\n    #050505;\n}\n\n/* ================= SHARED ================= */\n\n.acceHeroContent,\n.accePanel {\n  border: 1px solid rgba(177, 136, 0, 0.28);\n  border-radius: 18px;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015)),\n    #0b0b0b;\n  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);\n}\n\n.acceHeroContent,\n.accePanel {\n  padding: 20px;\n}\n\n.acceEyebrow,\n.acceSectionLabel,\n.acceInputLabel,\n.acceStatCard span,\n.acceSizingOutput span,\n.acceSizingMeta span,\n.acceInfoBlock span,\n.acceTradeTable th {\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.acceEyebrow,\n.acceSectionLabel,\n.acceInfoBlock span {\n  color: #d8b44c;\n  font-size: 0.72rem;\n}\n\n.accePanelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.accePanelHeader h3 {\n  margin: 6px 0 0;\n  color: #ffffff;\n  font-size: 1.15rem;\n  line-height: 1.2;\n}\n\n/* ================= PAGE LAYOUT ================= */\n\n.accePageGrid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(360px, 0.65fr);\n  gap: 18px;\n  align-items: start;\n}\n\n.acceLeftColumn,\n.acceRightColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n/* ================= HERO ================= */\n\n.acceHeroContent {\n  padding: 24px 28px;\n}\n\n.acceEyebrow {\n  display: inline-flex;\n  width: fit-content;\n  letter-spacing: 0.11em;\n}\n\n.acceHeroContent h1 {\n  margin: 10px 0 0;\n  color: #ffffff;\n  font-size: clamp(2.4rem, 4vw, 4rem);\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n}\n\n.acceHeroContent h2 {\n  margin: 8px 0 0;\n  color: #b18800;\n  font-size: clamp(1.2rem, 2vw, 1.7rem);\n  font-weight: 800;\n}\n\n.acceHeroContent p {\n  max-width: 900px;\n  margin: 14px 0 0;\n  color: rgba(244, 244, 244, 0.74);\n  font-size: 0.96rem;\n  line-height: 1.58;\n}\n\n/* ================= HERO ACTIONS ================= */\n\n.acceHeroActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.accePrimaryButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 11px 15px;\n  border: 1px solid rgba(177, 136, 0, 0.52);\n  border-radius: 12px;\n  color: #f4d06f;\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.18), rgba(255, 255, 255, 0.035)),\n    rgba(177, 136, 0, 0.08);\n  font-size: 0.82rem;\n  font-weight: 900;\n  text-decoration: none;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28);\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    transform 160ms ease;\n}\n\n.accePrimaryButton:hover {\n  border-color: rgba(216, 180, 76, 0.78);\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.26), rgba(255, 255, 255, 0.05)),\n    rgba(177, 136, 0, 0.12);\n  transform: translateY(-1px);\n}\n\n/* ================= STATS ================= */\n\n.acceStatsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.acceStatCard,\n.acceSizingMeta div,\n.acceInfoBlock {\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.035);\n}\n\n.acceStatCard {\n  min-width: 0;\n  padding: 16px;\n}\n\n.acceStatCard span,\n.acceSizingMeta span {\n  display: block;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.7rem;\n}\n\n.acceStatCard strong {\n  display: block;\n  margin-top: 10px;\n  color: #ffffff;\n  font-size: 1.45rem;\n  line-height: 1;\n}\n\n.acceStatCard small {\n  display: block;\n  margin-top: 8px;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.75rem;\n}\n\n.acceStatCard--positive strong {\n  color: #55d17a;\n}\n\n.acceStatCard--negative strong {\n  color: #ff6464;\n}\n\n.accePanelPill {\n  white-space: nowrap;\n  padding: 7px 10px;\n  border: 1px solid rgba(177, 136, 0, 0.42);\n  border-radius: 999px;\n  color: #f4d06f;\n  background: rgba(177, 136, 0, 0.08);\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n/* ================= TRADE TABLE ================= */\n\n.acceTradeTableWrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.acceTradeTable {\n  width: 100%;\n  min-width: 680px;\n  border-collapse: collapse;\n}\n\n.acceTradeTable th {\n  padding: 11px 12px;\n  color: rgba(244, 244, 244, 0.52);\n  font-size: 0.72rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.acceTradeTable td {\n  padding: 13px 12px;\n  color: rgba(244, 244, 244, 0.82);\n  font-size: 0.86rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n}\n\n.acceTradeTable tbody tr:hover {\n  background: rgba(177, 136, 0, 0.055);\n}\n\n.acceResultPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 9px;\n  border-radius: 999px;\n  color: rgba(244, 244, 244, 0.75);\n  background: rgba(255, 255, 255, 0.07);\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n\n.acceResultPill--positive {\n  color: #55d17a;\n  background: rgba(85, 209, 122, 0.1);\n}\n\n.acceResultPill--negative {\n  color: #ff6464;\n  background: rgba(255, 100, 100, 0.1);\n}\n\n.accePnlCell {\n  font-weight: 800;\n}\n\n.accePnlCell--positive {\n  color: #55d17a !important;\n}\n\n.accePnlCell--negative {\n  color: #ff6464 !important;\n}\n\n.acceEmptyTableCell {\n  padding: 18px 12px;\n  color: rgba(244, 244, 244, 0.48);\n  text-align: center;\n}\n\n.accePanelSubtext {\n  margin: 6px 0 0;\n  color: rgba(244, 244, 244, 0.48);\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n/* ================= CALCULATOR ================= */\n\n.acceCalculatorPanel {\n  border-color: rgba(216, 180, 76, 0.42);\n  background:\n    radial-gradient(circle at top right, rgba(177, 136, 0, 0.14), transparent 38%),\n    #0b0b0b;\n}\n\n.acceCalculatorIntro,\n.acceInfoBlock p {\n  margin: 0;\n  color: rgba(244, 244, 244, 0.68);\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.acceCalculatorIntro {\n  margin-bottom: 18px;\n}\n\n.acceInputLabel {\n  display: block;\n  margin-bottom: 8px;\n  color: rgba(244, 244, 244, 0.62);\n  font-size: 0.76rem;\n}\n\n.acceInputShell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 14px;\n  border: 1px solid rgba(177, 136, 0, 0.34);\n  border-radius: 14px;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.acceInputShell span {\n  color: #d8b44c;\n  font-weight: 900;\n}\n\n.acceInputShell input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  color: #ffffff;\n  background: transparent;\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.acceSizingOutput {\n  margin-top: 14px;\n  padding: 16px;\n  border: 1px solid rgba(177, 136, 0, 0.34);\n  border-radius: 16px;\n  background:\n    linear-gradient(145deg, rgba(177, 136, 0, 0.13), rgba(255, 255, 255, 0.03)),\n    rgba(0, 0, 0, 0.3);\n}\n\n.acceSizingOutput span {\n  display: block;\n  color: rgba(244, 244, 244, 0.58);\n  font-size: 0.68rem;\n}\n\n.acceSizingOutput strong {\n  display: block;\n  margin-top: 8px;\n  color: #ffffff;\n  font-size: 1.75rem;\n  line-height: 1.1;\n}\n\n.acceSizingOutput small {\n  display: block;\n  margin-top: 10px;\n  color: rgba(244, 244, 244, 0.56);\n  font-size: 0.82rem;\n}\n\n.acceSizingNotice {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border: 1px solid rgba(255, 193, 7, 0.28);\n  border-radius: 12px;\n  color: #f4d06f;\n  background: rgba(255, 193, 7, 0.08);\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.acceSizingMeta {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.acceSizingMeta div {\n  padding: 12px;\n  border-radius: 14px;\n}\n\n.acceSizingMeta strong {\n  display: block;\n  margin-top: 7px;\n  color: #ffffff;\n  font-size: 0.95rem;\n}\n\n.acceSizingDisclaimer {\n  margin: 14px 0 0;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.075);\n  color: rgba(244, 244, 244, 0.46);\n  font-size: 0.74rem;\n  line-height: 1.45;\n}\n\n/* ================= INFO ================= */\n\n.acceInfoStack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.acceInfoBlock {\n  padding: 14px;\n}\n\n.acceInfoBlock span {\n  display: block;\n  margin-bottom: 7px;\n}\n\n.acceWhitePaperLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  padding: 11px 14px;\n  border: 1px solid rgba(177, 136, 0, 0.42);\n  border-radius: 12px;\n  color: #f4d06f;\n  background: rgba(177, 136, 0, 0.08);\n  font-size: 0.82rem;\n  font-weight: 900;\n  text-decoration: none;\n  transition:\n    background 160ms ease,\n    border-color 160ms ease,\n    transform 160ms ease;\n}\n\n.acceWhitePaperLink:hover {\n  border-color: rgba(216, 180, 76, 0.72);\n  background: rgba(177, 136, 0, 0.16);\n  transform: translateY(-1px);\n}\n\n/* ================= DISCLAIMER ================= */\n\n.acceDisclaimer {\n  margin-top: 18px;\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.075);\n  border-radius: 14px;\n  color: rgba(244, 244, 244, 0.42);\n  background: rgba(255, 255, 255, 0.025);\n  font-size: 0.74rem;\n  line-height: 1.45;\n}\n\n/* ================= RESPONSIVE ================= */\n\n@media (max-width: 1180px) {\n  .accePageGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 860px) {\n  .accePage {\n    padding: 16px;\n  }\n\n  .acceStatsGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .acceHeroContent,\n  .accePanel {\n    border-radius: 16px;\n  }\n}\n\n@media (max-width: 560px) {\n  .acceStatsGrid,\n  .acceSizingMeta {\n    grid-template-columns: 1fr;\n  }\n\n  .accePanelHeader {\n    flex-direction: column;\n  }\n\n  .acceHeroContent,\n  .accePanel {\n    padding: 16px;\n  }\n}\n\n\n\n/*These fixes are for the mobile views to align with argos and meic*/\n\n/* ================= MOBILE WIDTH / OVERFLOW FIX ================= */\n\n.accePage,\n.accePageGrid,\n.acceLeftColumn,\n.acceRightColumn,\n.acceHeroContent,\n.accePanel {\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.accePage {\n  overflow-x: hidden;\n}\n\n.acceHeroContent {\n  position: relative;\n  overflow: hidden;\n}\n\n.acceHeroContent h1,\n.acceHeroContent h2,\n.acceHeroContent p {\n  max-width: 100%;\n  overflow-wrap: break-word;\n}\n\n.acceHeroActions {\n  flex-wrap: wrap;\n}\n\n.accePrimaryButton {\n  max-width: 100%;\n  white-space: normal;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
